import {
  MenuTextMatch,
  PUNCTUATION,
} from "@lexical/react/LexicalTypeaheadMenuPlugin";
import { GenericNode, Trigger, SuggestionData } from "./type";
import { KeyType } from "relay-runtime/store/RelayStoreTypes";

const PRE_TRIGGER_CHARS: string = "\\(";
const LENGTH_LIMIT: number = 75;

type MentionsResult = MenuTextMatch | null;

function buildSuggestionRegexp(
  triggers: Trigger[],
  preTriggerChars: string = PRE_TRIGGER_CHARS,
  punctuation: string = PUNCTUATION,
  allowSpaces: boolean = false,
): RegExp {
  const triggersPattern = triggers.length ? `(?:${triggers.join("|")})` : "";
  const spacePattern = allowSpaces ? `(?:[.${punctuation}])?` : "";
  const matchingPattern = `([^\\s${punctuation}]${spacePattern}{0,${LENGTH_LIMIT}})`;
  const pattern = `(^|\\s|${preTriggerChars})(${triggersPattern}${matchingPattern})$`;

  return new RegExp(pattern);
}

export const MENTION_REGEXP = buildSuggestionRegexp(["@"]);

export const checkForMentions = (
  regexp: RegExp,
  text: string,
): MentionsResult => {
  const match = regexp.exec(text);
  return match
    ? {
        leadOffset: match.index + match[1].length,
        matchingString: match[3],
        replaceableString: match[2],
      }
    : null;
};

export function getNode<TKey extends KeyType>(
  node: GenericNode<TKey>["node"],
): SuggestionData<TKey> {
  if ("key" in node) {
    return node as SuggestionData<TKey>;
  } else if ("entity" in node && "key" in node.entity) {
    return node.entity as SuggestionData<TKey>;
  }
  throw new Error("Invalid node structure");
}
